<template>
  <div class="container" v-show="showBubble" v-on:click="showBubble = !showBubble">
    <div class="bubble">
      <div class="row">
        <div>
          <img class="blueLogo" src="../assets/VirtualAssistant_Heading-01.png" width="167" height="20">
        </div>
        <CloseButton v-on:click="showBubble = !showBubble"></CloseButton>
      </div>
      <div class="row">
        <div class="space"></div>
      </div>
      <div class="row">
        <p>{{ bubbleText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import CloseButton from './CloseButton.vue'

export default {
  components: {
    'CloseButton': CloseButton
  },

  data () {
    return {
      showBubble: true,
      bubbleText: 'Hi! If you\'re interested in renting with us, have questions about availability, or want to book a viewing, I\'m happy to help! 😊'
    }
  }
}
</script>

<style>
.bubble {
  background-color: #FFFFFF;
  border: 1px solid #f7f6f6;
  padding-right: 20px;
  padding-left: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  max-width: 100%;
  border-radius: 5px;
  display: inline-block;
  flex-direction: column;
  overflow: hidden;
  position: absolute;
  text-align: left;
  font-size: 14px;
  color: #000000;
  font-family: "Arial";
  bottom: 100px;
  width: 300px;
  -webkit-filter: drop-shadow(0px 0px 5px #d7d5d5);
  filter: drop-shadow(0px 0px 5px #d7d5d5);
  animation: fadeIn 1s linear, wave 2.5s linear;
  right: 20px;
}

.blueLogo {
  margin-top: 10px;
}

.space {
  padding-top: 20px;
}

@keyframes wave {
  0%, 60%, 100% {
    transform: initial;
  }

  30% {
    transform: translateY(-10px);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  66% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChatBubble2.vue